import { useEffect, useState } from "react";
import Button from "../../Custom/Button/Button";
import "./selectedNavbar.css";
import TurnLeftIcon from "@mui/icons-material/TurnLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import { useGlobalContext } from "../../../Context/Context";

import BackIcon from "../../picture/Back.png";
import LeftIcon from "../../picture/left-image-play.png";
import RightIcon from "../../picture/right-image-play.png";

const SelectedNavbar = ({
  data,
  list,
  chooseObject,
  setChooseObject,
  handleBack,
  currentIndex,
}) => {
  const { selectedSettings, setSelectedSettings } = useGlobalContext();

  const handleSelectedSettings = (index) => {
    setSelectedSettings(index);
  };

  const handlePrevious = () => {
    /*if (selectedSettings === 0) setSelectedSettings(0);
    else setSelectedSettings(selectedSettings - 1);*/
    if (currentIndex === 0) return;
    else {
      const newCurrentIndex = currentIndex - 1;
      console.log(chooseObject);
      setChooseObject({
        ...chooseObject,
        currentIndex: newCurrentIndex,
        data: data[newCurrentIndex].name,
        id:
          chooseObject.index === 3
            ? parseInt(data[newCurrentIndex].location_id)
            : parseInt(data[newCurrentIndex].user_id),
      });
    }
  };

  const handleNext = () => {
    /*if (selectedSettings === list.length - 1)
      setSelectedSettings(list.length - 1);
    else setSelectedSettings(selectedSettings + 1);*/
    if (currentIndex === data.length - 1) return;
    else {
      const newCurrentIndex = currentIndex + 1;
      console.log(chooseObject);
      setChooseObject({
        ...chooseObject,
        currentIndex: newCurrentIndex,
        data: data[newCurrentIndex].name,
        id:
          chooseObject.index === 3
            ? parseInt(data[newCurrentIndex].location_id)
            : parseInt(data[newCurrentIndex].user_id),
      });
    }
  };

  return (
    <div className="selected-navbar">
      <Button active={false} activation={true}>
        <div className="selected-navbar-wrapper">
          <div className="selected-navbar-header">
            <div className="selected-navbar-button" onClick={handleBack}>
              <Button activation={true}>
                <img src={BackIcon} />
              </Button>
            </div>
            {data.length > 1 && (
              <div className="selected-navbar-button" onClick={handlePrevious}>
                <Button activation={true}>
                  <img className="left-right-icon-nav" src={LeftIcon} />
                </Button>
              </div>
            )}
            <h6>{chooseObject.data}</h6>
            {data.length > 1 && (
              <div className="selected-navbar-button" onClick={handleNext}>
                <Button activation={true}>
                  <img className="left-right-icon-nav" src={RightIcon} />
                </Button>
              </div>
            )}
          </div>
        </div>
      </Button>
      <div className="selected-navbar-list">
        {list.length !== 0 &&
          list.map((item, index) => {
            return (
              <div
                key={index}
                className="button-selected-navbar"
                onClick={() => handleSelectedSettings(index)}
              >
                <Button active={selectedSettings === index}>{item}</Button>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default SelectedNavbar;
